<template>
  <div class="w-12 h-12 relative">
    <div
      class="w-full h-full"
      :class="{
        'clip-circle-bottom-right': actionIcon,
      }"
    >
      <slot name="avatar">
        <AsyncImage
          src="/apple-touch-icon.png"
          class="w-10 h-10 object-cover rounded-full self-start"
        />
      </slot>
    </div>
    <div class="absolute right-0 bottom-[-0.0625rem]">
      <slot name="action">
        <component
          v-if="actionIcon"
          :is="actionIcon"
          :size="20"
          class="text-nami-comi-blue p-[0.175rem] rounded-full bg-neutral-300 dark:bg-neutral-700"
        />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconPlaceholder } from "@tabler/icons-vue";

defineProps<{
  actionIcon?: typeof IconPlaceholder;
}>();
</script>

<style>
.clip-circle-bottom-right {
  /* We can only use px values on path() alas */
  clip-path: path(
    "M -8 -8 L 48 -8 L 48 24 L 40 24 C 30,24 24,30 24,40 L 24,48 L -8 48 L -8 -8 Z"
  );
}
</style>
